import { useEffect } from "react";

/**
 * 화면마다 문서 제목을 달아요 — `"규칙 · 트랑슈"`.
 *
 * SPA 라서 `index.html` 의 `<title>` 하나가 모든 경로에 그대로 남아 있었어요. 탭이 여러 개
 * 열려 있으면 전부 같은 이름이라 어느 탭이 주문 화면인지 알 수 없고, 방문 기록·북마크도
 * 같은 문장으로 쌓였습니다.
 *
 * 떠날 때 원래 제목으로 되돌려요. 제목을 달지 않는 화면(랜딩·로그인)이 앞 화면의 이름을
 * 물려받으면 안 됩니다.
 */
export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} · 트랑슈`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
